import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "mb-2" }
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = ["type"]
const _hoisted_4 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_5 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_6 = {
  key: 0,
  class: "text-red-600 text-sm mt-1"
}
const _hoisted_7 = {
  key: 0,
  class: "mb-4 text-xs space-y-1"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "relative mb-4" }
const _hoisted_19 = { class: "relative" }
const _hoisted_20 = ["type"]
const _hoisted_21 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_22 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_23 = {
  key: 0,
  class: "text-red-600 text-sm mt-1"
}
const _hoisted_24 = ["disabled"]

import { computed, ref } from "vue";
import { useForm } from "vee-validate";
import { toTypedSchema } from "@vee-validate/yup";
import * as yup from "yup";
import { useMutation } from "@tanstack/vue-query";
import { resetPasswordAction } from "../../actions/resetPassword.action";
import ResetHeader from "./ResetHeader.vue";
import { useToast } from "vue-toastification";


export default /*@__PURE__*/_defineComponent({
  __name: 'StepNewPassword',
  props: {
    email: {},
    token: {}
  },
  emits: ["success"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const showPassword = ref(false);
const showConfirmPassword = ref(false);
const toast = useToast();

const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&._-])[A-Za-z\d@$!%*?&._-]{8,}$/;

const newPasswordSchema = toTypedSchema(
  yup.object({
    password: yup
      .string()
      .required("La contraseña es obligatoria")
      .matches(
        PASSWORD_REGEX,
        "La contraseña debe cumplir todos los requisitos indicados"
      ),
    confirmPassword: yup
      .string()
      .required("Confirma tu contraseña")
      .oneOf([yup.ref("password")], "Las contraseñas no coinciden"),
  })
);

const { defineField, errors, handleSubmit, values, resetForm } = useForm({
  validationSchema: newPasswordSchema,
  initialValues: {
    password: "",
    confirmPassword: "",
  },
});

const [password] = defineField("password");
const [confirmPassword] = defineField("confirmPassword");

const passwordValidation = computed(() => {
  const pwd = values.password || "";
  return {
    minLength: pwd.length >= 8,
    hasUpperCase: /[A-Z]/.test(pwd),
    hasLowerCase: /[a-z]/.test(pwd),
    hasNumber: /\d/.test(pwd),
    hasSpecialChar: /[@$!%*?&._-]/.test(pwd),
  };
});

const { mutate, isPending } = useMutation({
  mutationFn: async (newPassword: string) => {
    if (!props.token) {
      throw new Error("Token no disponible");
    }
    const response = await resetPasswordAction(newPassword, props.token);

    if (response.status !== 200 || !response.data) {
      throw new Error(response.message || "Error al actualizar la contraseña");
    }

    return response;
  },
  onSuccess: (data) => {
    toast.success(data.message || "Contraseña actualizada exitosamente");
    emit("success");

    setTimeout(() => {
      resetForm();
    }, 1500);
  },
  onError: (err: Error) => {
    toast.error(err.message || "Error al actualizar la contraseña");
  },
});

const onSubmit = handleSubmit((vals) => {
  mutate(vals.password);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ResetHeader, {
      title: "Nova",
      subtitle: "Innovación de ventas sin límites"
    }),
    _createElementVNode("form", {
      class: "p-8",
      onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args)), ["prevent"]))
    }, [
      _cache[16] || (_cache[16] = _createElementVNode("h2", { class: "text-2xl font-bold mb-4" }, "Nueva Contraseña", -1)),
      _createElementVNode("div", _hoisted_1, [
        _cache[7] || (_cache[7] = _createElementVNode("label", { class: "block text-sm font-semibold text-slate-700 mb-2" }, [
          _createTextVNode(" Nueva contraseña "),
          _createElementVNode("span", { class: "text-red-500" }, "*")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(password) ? (password).value = $event : null)),
            type: showPassword.value ? 'text' : 'password',
            placeholder: "Nueva contraseña",
            class: _normalizeClass(["w-full border-2 border-gray-200 rounded-xl py-3 px-4 pr-12", _unref(errors).password ? 'border-red-400' : '']),
            autocomplete: "new-password"
          }, null, 10, _hoisted_3), [
            [_vModelDynamic, _unref(password)]
          ]),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (showPassword.value = !showPassword.value)),
            class: "absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
          }, [
            (!showPassword.value)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_4, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                  }, null, -1),
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                  }, null, -1)
                ]))]))
              : (_openBlock(), _createElementBlock("svg", _hoisted_5, [...(_cache[6] || (_cache[6] = [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
                  }, null, -1)
                ]))]))
          ])
        ]),
        (_unref(errors).password)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_unref(errors).password), 1))
          : _createCommentVNode("", true)
      ]),
      (_unref(password))
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("p", {
              class: _normalizeClass(passwordValidation.value.minLength ? 'text-green-600' : 'text-gray-500')
            }, [
              (passwordValidation.value.minLength)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "✓"))
                : (_openBlock(), _createElementBlock("span", _hoisted_9, "○")),
              _cache[8] || (_cache[8] = _createTextVNode(" Mínimo 8 caracteres ", -1))
            ], 2),
            _createElementVNode("p", {
              class: _normalizeClass(passwordValidation.value.hasUpperCase ? 'text-green-600' : 'text-gray-500')
            }, [
              (passwordValidation.value.hasUpperCase)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, "✓"))
                : (_openBlock(), _createElementBlock("span", _hoisted_11, "○")),
              _cache[9] || (_cache[9] = _createTextVNode(" Al menos una mayúscula ", -1))
            ], 2),
            _createElementVNode("p", {
              class: _normalizeClass(passwordValidation.value.hasLowerCase ? 'text-green-600' : 'text-gray-500')
            }, [
              (passwordValidation.value.hasLowerCase)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, "✓"))
                : (_openBlock(), _createElementBlock("span", _hoisted_13, "○")),
              _cache[10] || (_cache[10] = _createTextVNode(" Al menos una minúscula ", -1))
            ], 2),
            _createElementVNode("p", {
              class: _normalizeClass(passwordValidation.value.hasNumber ? 'text-green-600' : 'text-gray-500')
            }, [
              (passwordValidation.value.hasNumber)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, "✓"))
                : (_openBlock(), _createElementBlock("span", _hoisted_15, "○")),
              _cache[11] || (_cache[11] = _createTextVNode(" Al menos un número ", -1))
            ], 2),
            _createElementVNode("p", {
              class: _normalizeClass(passwordValidation.value.hasSpecialChar ? 'text-green-600' : 'text-gray-500')
            }, [
              (passwordValidation.value.hasSpecialChar)
                ? (_openBlock(), _createElementBlock("span", _hoisted_16, "✓"))
                : (_openBlock(), _createElementBlock("span", _hoisted_17, "○")),
              _cache[12] || (_cache[12] = _createTextVNode(" Al menos un carácter especial (@$!%*?&._-) ", -1))
            ], 2)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_18, [
        _cache[15] || (_cache[15] = _createElementVNode("label", { class: "block text-sm font-semibold text-slate-700 mb-2" }, [
          _createTextVNode(" Confirmar contraseña "),
          _createElementVNode("span", { class: "text-red-500" }, "*")
        ], -1)),
        _createElementVNode("div", _hoisted_19, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(confirmPassword) ? (confirmPassword).value = $event : null)),
            type: showConfirmPassword.value ? 'text' : 'password',
            placeholder: "Confirmar contraseña",
            class: _normalizeClass(["w-full border-2 border-gray-200 rounded-xl py-3 px-4 pr-12", _unref(errors).confirmPassword ? 'border-red-400' : '']),
            autocomplete: "new-password"
          }, null, 10, _hoisted_20), [
            [_vModelDynamic, _unref(confirmPassword)]
          ]),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (showConfirmPassword.value = !showConfirmPassword.value)),
            class: "absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
          }, [
            (!showConfirmPassword.value)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_21, [...(_cache[13] || (_cache[13] = [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                  }, null, -1),
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                  }, null, -1)
                ]))]))
              : (_openBlock(), _createElementBlock("svg", _hoisted_22, [...(_cache[14] || (_cache[14] = [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
                  }, null, -1)
                ]))]))
          ])
        ]),
        (_unref(errors).confirmPassword)
          ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(_unref(errors).confirmPassword), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("button", {
        type: "submit",
        disabled: _unref(isPending),
        class: "w-full bg-slate-900 text-white py-3 rounded-xl disabled:bg-gray-400 disabled:cursor-not-allowed hover:bg-slate-800 transition-colors"
      }, _toDisplayString(_unref(isPending) ? "Actualizando..." : "ACTUALIZAR CONTRASEÑA"), 9, _hoisted_24)
    ], 32)
  ]))
}
}

})